import React from 'react';
import classes from "./BannerSection.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { BannerCardData } from '../../data/app-data';
import BannerCard from '../../components/BannerCard';

export default function BannerSection() {
    return (
        <div className={classes.mainDiv} id='home'>
            <Container>
                <Row>
                    <Header />
                </Row>
                <Row className='mt-5'>
                    <Col xl={6} md={12}>
                        <h1 className={`${classes.heading} fw-600`}>Elevating Your Business to New Heights</h1>
                        <p className={`f-16 mt-3 ${classes.para}`}>ARK Consulting Services LLC provides strategic consulting services for the various industries. These services include accounting, strategic consulting, accounting  services and management consulting</p>
                        <Row className='mt-5 gy-3'>
                            <Col md={4}>
                                <Button label={"get started"} variant={"gradient"} className={classes.btnClass} /></Col>
                            <Col md={4}>
                                <Button label={"learn more"} variant={"outlined-white"} className={classes.btnClass} /></Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='mt-5 g-1'>
                    {BannerCardData?.map((e, i) => {
                        return (
                            <Col md={4} key={i} className='mt-2'>
                                <BannerCard data={e} />
                            </Col>
                        )
                    })}
                </Row>
            </Container>
        </div>
    )
}
